import { Component, Input, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NiceLayoutModule } from "@recursyve/nice-ui-kit.v2";

@Component({
    selector: "nerri-public-page",
    templateUrl: "./public-page.template.html",
    styleUrls: ["./public-page.style.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [NiceLayoutModule, TranslateModule]
})
export class PublicPageComponent {
    @Input({ required: true })
    public organisationLogo: string | null;
}
